import InnerHTML from 'dangerously-set-html-content';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import { taggedStylesToString, withTheme } from 'common/styling/theme';
import { getDynamicStyles, staticStyles } from './style';

const Tooltip = ({
  id,
  textId,
  noTranslate,
  place,
  effect,
  formattedValues,
  children,
  theme,
  isHTML,
  clickable,
  textExtraclass,
  spanAbsolute,
}) => {
  const dynamicStyles = Object.keys(theme).length ? taggedStylesToString(getDynamicStyles(theme)) : ` `;
  return (
    <>
      {textId ? (
        <>
          <span
            data-tooltip-id={id}
            className={`Tooltip__text ${textExtraclass} ${spanAbsolute ? 'Tooltip--Span-PositionAbsolute' : ''}`}>
            {children}
          </span>
          <ReactTooltip
            {...(spanAbsolute ? { position: 'fixed' } : {})}
            clickable={clickable}
            id={id}
            className="Tooltip"
            place={place}
            effect={effect}>
            {noTranslate ? (
              isHTML ? (
                <InnerHTML html={textId} />
              ) : (
                <pre>{textId}</pre>
              )
            ) : (
              <FormattedMessage id={textId} values={formattedValues}>
                {txt => <pre>{txt}</pre>}
              </FormattedMessage>
            )}
          </ReactTooltip>
        </>
      ) : (
        children
      )}

      <style jsx global>
        {staticStyles}
      </style>
      <style>{dynamicStyles}</style>
    </>
  );
};

Tooltip.propTypes = {
  id: PropTypes.string,
  textId: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  noTranslate: PropTypes.bool,
  isHTML: PropTypes.bool,
  clickable: PropTypes.bool,
  place: PropTypes.string,
  effect: PropTypes.string,
  children: PropTypes.node,
  formattedValues: PropTypes.object,
  theme: PropTypes.object,
};

Tooltip.defaultProps = {
  id: null,
  children: null,
  textId: '',
  noTranslate: false,
  isHTML: false,
  clickable: false,
  place: 'top',
  effect: 'solid',
  formattedValues: {},
  theme: {},
};

export default withTheme()(Tooltip);
export { Tooltip };
